<template>
  <div class="countdown">
    <h2 v-if="$store.state.repId == '23'">CUENTA REGRESIVA HACIA EL COMIENZO</h2>
    <h2 v-else>Countdown to Kickoff</h2>
    <div class="countdown-elements">
      <div class="countdown-element days">
        <div class="value">{{ days }}</div>
        <div v-if="$store.state.repId == '23'" class="label">Días</div>
        <div v-else class="label">Days</div>
      </div>
      <div class="countdown-element hours">
        <div class="value">{{ hours }}</div>
        <div v-if="$store.state.repId == '23'" class="label">Horas</div>
        <div v-else class="label">Hours</div>
      </div>
      <div class="countdown-element mins">
        <div class="value">{{ minutes }}</div>
        <div v-if="$store.state.repId == '23'" class="label">Minutos</div>
        <div v-else class="label">Mins</div>
      </div>
      <div class="countdown-element secs">
        <div class="value">{{ seconds }}</div>
        <div v-if="$store.state.repId == '23'" class="label">Segundos</div>
        <div v-else class="label">Secs</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  data() {
    return {
      now:new Date(),
      deadline:new Date('2025-02-22T00:00:00-08:00'),
    }
  },  
  mounted() {
    this.updateNow();
    setTimeout(this.updateNow, 1000)
  },
  methods : {
    updateNow() {
      let nowUTC = new Date();
      this.now = new Date(nowUTC.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
      setTimeout(this.updateNow, 1000)
    },
    format(value) {
      return value < 10 ? `0${value}` : value;
    }
  },
  computed: {    
    timeDiff() {
      return this.deadline.getTime() - this.now.getTime();
    },
    days() {
      return this.format(Math.floor(this.timeDiff / (1000 * 60 * 60 * 24)));      
    },
    hours() {
      return this.format(Math.floor((this.timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    },
    minutes() {
      return this.format(Math.floor((this.timeDiff % (1000 * 60 * 60)) / (1000 * 60)));
    },
    seconds() {
      return this.format(Math.floor((this.timeDiff % (1000 * 60)) / 1000));
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: var(--white);
  text-align: center;
  font-size: 24px;
  line-height: 1;
  letter-spacing: 0.72px;
  font-style: italic;
}
.countdown {
  text-transform: uppercase;
  text-align: center;
  padding-top: 30px;
}
.countdown-elements {
  display: flex;
  justify-content: center;
  padding-top:14px;
}
.countdown-element {
  flex-grow: 1;

}
.value {
  font-family: "Modern Era";
  color: var(--white);
  font-size: 37px;
  font-weight: bold;
  line-height: 0.64;
}
.label {
  font-family: "Modern Era";
  margin-top: 15px;
  color: var(--white);
  font-size: 10px;
  line-height: 1;
}
</style>